import { createSelector } from 'reselect';
import { RootState } from 'store';
import adapter from './settlements.adapter';
import { REDUCER_KEY } from './settlements.consts';
import { SettlementParams } from './settlements.types';
import { selectCurrentProposal } from 'store/proposals';
import { selectCurrentCommittedProposal } from 'store/proposals/committed';
import { selectCurrentCampaign } from 'store/campaigns';

const selectors = adapter.getSelectors(
  (state: RootState) => state[REDUCER_KEY],
);
export const { selectIds, selectTotal, selectAll } = selectors;

export const selectById = (
  state: RootState,
  id: number,
): SettlementParams | null => selectors.selectById(state, id) || null;

export const selectAllSettlements = createSelector(
  state => selectors.selectAll(state),
  settlements => settlements || [],
);

export const selectSettlementsForCurrentProposal = createSelector(
  selectCurrentProposal,
  selectAllSettlements,
  (currentProposal, settlements) =>
    settlements.filter(
      ({ proposal }) => proposal?.id && proposal.id === currentProposal?.id,
    ),
);

export const selectSettlementsForCurrentCommittedProposal = createSelector(
  selectCurrentCommittedProposal,
  selectAllSettlements,
  (currentCommittedProposal, settlements) =>
    settlements.filter(
      ({ proposal }) =>
        proposal?.id && proposal.id === currentCommittedProposal?.id,
    ),
);

export const selectSettlementsForCurrentCampaign = createSelector(
  selectCurrentCampaign,
  selectAllSettlements,
  (currentCampaign, settlements) =>
    settlements.filter(
      ({ proposal }) =>
        proposal?.id && proposal.id === currentCampaign?.proposalId,
    ),
);

export function selectSettlement(
  state: RootState,
  settlementId: number,
): SettlementParams | undefined {
  return selectors.selectById(state, settlementId) || undefined;
}
